import React from "react";

import Banner from "../banner";
import LoginNotification from "../loginNotification";

const PortalNotifications = ({
  banners = [],
  notifications = [],
  onDismissBanner,
  onDismissNotification,
}) => {
  return (
    <>
      {banners.map((banner) => (
        <Banner
          key={banner?.id}
          notificationType={banner?.notificationType}
          displayMessage={banner?.displayMessage || banner?.displayTitle}
          canDismiss={banner?.canDismiss}
          link={banner?.link}
          onClose={() => onDismissBanner?.(banner?.id)}
        />
      ))}
      {!!notifications.length && (
        <div className="login-page-notification-stack">
          {notifications.map((notification) => (
            <LoginNotification
              key={notification?.id}
              notificationType={notification?.notificationType}
              displayTitle={notification?.displayTitle}
              displayMessage={notification?.displayMessage}
              notificationImage={notification?.notificationImage}
              link={notification?.link}
              onClose={() => onDismissNotification?.(notification?.id)}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default PortalNotifications;
